<div class="main-wrapper">
  <div class="outer-wrapper">
    <div class="common-background-section">
      <div class="div">
        <div class="past-payroll-header">
          <div class="past-back-common" *ngIf="!showSkeleton">
            <svg (click)="goBack()" width="18" height="14" viewBox="0 0 18 14" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M17 7H1M1 7L7 13M1 7L7 1" stroke="#2D2D2E" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <h1 *ngIf="!showSkeleton">Past Payrolls</h1>
          </div>
          <button class="add-payroll-btn" (click)="setSelectedUser(detailData?.user_detail)" data-toggle="modal"
            data-target="#userpayrollModal" *ngIf="!showSkeleton">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.75 6.75V14.75M6.75 10.75H14.75M20.75 10.75C20.75 16.2728 16.2728 20.75 10.75 20.75C5.22715 20.75 0.75 16.2728 0.75 10.75C0.75 5.22715 5.22715 0.75 10.75 0.75C16.2728 0.75 20.75 5.22715 20.75 10.75Z"
                stroke="#FAFAFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Add Payroll
          </button>
          <div class="payroll-summary-header-body-item release-amount skeleton-small-div skiliton-buttons"
            *ngIf="showSkeleton"></div>
          <div class="payroll-summary-header-body-item release-amount skeleton-small-div skiliton-buttons"
            *ngIf="showSkeleton"></div>

        </div>
        <div class="past-payroll-body">
          <div class="user-details">
            <div class="user-detail-head" *ngIf="!showSkeleton">
              <div class="user-profile-image">
                <img [src]="detailData?.user_detail?.profile_image || '../../../../assets/fake-profile.jpg'"
                  alt="user-profile" />
              </div>
              <div class="user-profile-info">
                <h1>{{ detailData?.user_detail?.first_name }} {{ detailData?.user_detail?.last_name }}</h1>
                <p>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1.5 5.25L7.62369 9.53658C8.11957 9.8837 8.36751 10.0573 8.6372 10.1245C8.87542 10.1839 9.12458 10.1839 9.3628 10.1245C9.63249 10.0573 9.88043 9.8837 10.3763 9.53658L16.5 5.25M5.1 15H12.9C14.1601 15 14.7902 15 15.2715 14.7548C15.6948 14.539 16.039 14.1948 16.2548 13.7715C16.5 13.2902 16.5 12.6601 16.5 11.4V6.6C16.5 5.33988 16.5 4.70982 16.2548 4.22852C16.039 3.80516 15.6948 3.46095 15.2715 3.24524C14.7902 3 14.1601 3 12.9 3H5.1C3.83988 3 3.20982 3 2.72852 3.24524C2.30516 3.46095 1.96095 3.80516 1.74524 4.22852C1.5 4.70982 1.5 5.33988 1.5 6.6V11.4C1.5 12.6601 1.5 13.2902 1.74524 13.7715C1.96095 14.1948 2.30516 14.539 2.72852 14.7548C3.20982 15 3.83988 15 5.1 15Z"
                      stroke="#2D2D2E" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  {{ detailData?.user_detail?.email }}
                </p>
                <p>
                  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.5 13.25C2.25184 11.3919 4.63026 10.25 7.25 10.25C9.86974 10.25 12.2482 11.3919 14 13.25M10.625 3.875C10.625 5.73896 9.11396 7.25 7.25 7.25C5.38604 7.25 3.875 5.73896 3.875 3.875C3.875 2.01104 5.38604 0.5 7.25 0.5C9.11396 0.5 10.625 2.01104 10.625 3.875Z"
                      stroke="#2D2D2E" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  ID: {{ detailData?.user_detail?.attendance_user_id || detailData?.user_detail?.attendance_user_id }}
                </p>
              </div>
            </div>
            <div class="user-info-detail" *ngIf="!showSkeleton">
              <h1>User Details</h1>
              <div class="detail-infor-sec">
                <div class="detail-info-icon">
                  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 6.5H0.5M10.25 0.5V3.5M4.25 0.5V3.5M4.1 15.5H10.4C11.6601 15.5 12.2902 15.5 12.7715 15.2548C13.1948 15.039 13.539 14.6948 13.7548 14.2715C14 13.7902 14 13.1601 14 11.9V5.6C14 4.33988 14 3.70982 13.7548 3.22852C13.539 2.80516 13.1948 2.46095 12.7715 2.24524C12.2902 2 11.6601 2 10.4 2H4.1C2.83988 2 2.20982 2 1.72852 2.24524C1.30516 2.46095 0.96095 2.80516 0.745235 3.22852C0.5 3.70982 0.5 4.33988 0.5 5.6V11.9C0.5 13.1601 0.5 13.7902 0.745235 14.2715C0.96095 14.6948 1.30516 15.039 1.72852 15.2548C2.20982 15.5 2.83988 15.5 4.1 15.5Z"
                      stroke="#00989B" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="details-info-content">
                  <p>Joining Date</p>
                  <p class="content-bold">{{ formatDate(detailData?.user_detail?.joining_date) }}</p>
                </div>
              </div>
              <div class="detail-infor-sec">
                <div class="detail-info-icon">
                  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.5 13.25C2.25184 11.3919 4.63026 10.25 7.25 10.25C9.86974 10.25 12.2482 11.3919 14 13.25M10.625 3.875C10.625 5.73896 9.11396 7.25 7.25 7.25C5.38604 7.25 3.875 5.73896 3.875 3.875C3.875 2.01104 5.38604 0.5 7.25 0.5C9.11396 0.5 10.625 2.01104 10.625 3.875Z"
                      stroke="#00989B" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="details-info-content">
                  <p>Employment Status</p>
                  <p class="content-bold">{{ detailData?.user_detail?.employee_type }} ({{
                    detailData?.user_detail?.employee_status }})</p>
                </div>
              </div>
              <div class="detail-infor-sec">
                <div class="detail-info-icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.4214 8.08785C15.4214 3.8972 12.0242 0.5 7.83351 0.5C4.43225 0.5 1.55367 2.73789 0.589883 5.82155C0.528145 6.01908 0.497276 6.11785 0.500189 6.24136C0.502557 6.34178 0.533082 6.46585 0.57758 6.55591C0.632305 6.66666 0.716802 6.75116 0.88579 6.92014L9.00154 15.0355C9.17052 15.2045 9.25503 15.289 9.36579 15.3437C9.45585 15.3882 9.57991 15.4187 9.68034 15.4211C9.80384 15.424 9.90261 15.3931 10.1001 15.3314C13.1836 14.3675 15.4214 11.489 15.4214 8.08785Z"
                      stroke="#00989B" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M1.506 6.30057C1.68637 6.28774 1.8685 6.28122 2.05214 6.28122C6.24279 6.28122 9.63999 9.67842 9.63999 13.8691C9.63999 14.0527 9.63347 14.2348 9.62064 14.4152C9.59822 14.7304 9.58702 14.8879 9.49515 14.9852C9.42055 15.0643 9.29323 15.1118 9.18508 15.101C9.05192 15.0876 8.93082 14.9665 8.68862 14.7243L1.19688 7.23259C0.954678 6.99039 0.833579 6.86929 0.82024 6.73613C0.809406 6.62798 0.856921 6.50066 0.935964 6.42605C1.03328 6.33419 1.19085 6.32299 1.506 6.30057Z"
                      stroke="#00989B" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="details-info-content">
                  <p>Designation</p>
                  <p class="content-bold">{{ detailData?.user_detail?.designation?.designation_name || 'N/A' }}</p>
                </div>
              </div>
              <div class="detail-infor-sec border-none">
                <div class="detail-info-icon">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8 0.875V2.9C8 4.16012 8 4.79018 8.24524 5.27148C8.46095 5.69484 8.80516 6.03905 9.22852 6.25476C9.70982 6.5 10.3399 6.5 11.6 6.5H13.625M14 7.99117V10.4C14 11.6601 14 12.2902 13.7548 12.7715C13.539 13.1948 13.1948 13.539 12.7715 13.7548C12.2902 14 11.6601 14 10.4 14H4.1C2.83988 14 2.20982 14 1.72852 13.7548C1.30516 13.539 0.96095 13.1948 0.745235 12.7715C0.5 12.2902 0.5 11.6601 0.5 10.4V4.1C0.5 2.83988 0.5 2.20982 0.745235 1.72852C0.96095 1.30516 1.30516 0.96095 1.72852 0.745235C2.20982 0.5 2.83988 0.5 4.1 0.5H6.50883C7.05916 0.5 7.33432 0.5 7.59327 0.562168C7.82285 0.617285 8.04233 0.708195 8.24364 0.83156C8.4707 0.970704 8.66527 1.16527 9.05442 1.55442L12.9456 5.44559C13.3347 5.83473 13.5293 6.0293 13.6684 6.25636C13.7918 6.45767 13.8827 6.67715 13.9378 6.90673C14 7.16568 14 7.44084 14 7.99117Z"
                      stroke="#00989B" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="details-info-content">
                  <p>Department</p>
                  <p class="content-bold">{{ detailData?.user_detail?.department }}</p>
                </div>
              </div>
            </div>

            <div class="payroll-summary-header-body-item release-amount skeleton-big-div" *ngIf="showSkeleton"></div>

          </div>
          <div class="payroll-details">
            <div class="payroll-detail-head">
              <div class="payroll-summary-header-body-item gross-amount" *ngIf="!showSkeleton">
                <div class="card-head">
                  <div class="card-img">
                    <img src="../../../../assets/theme1/smal-icons/tenure.png" />
                  </div>
                  <div class="card-content">
                    <p><span>Total</span>Tenure</p>
                    <h2>{{ detailData?.tenure }}</h2>
                  </div>
                </div>
              </div>
              <div class="payroll-summary-header-body-item release-amount" *ngIf="!showSkeleton">
                <div class="card-head">
                  <div class="card-img">
                    <img src="../../../../assets/theme1/smal-icons/release-amount.png" />
                  </div>
                  <div class="card-content">
                    <p><span>Total</span> Earning</p>
                    <h2>{{ detailData?.summary?.total_earning | number }} /- PKR</h2>
                  </div>
                </div>
              </div>

              <div class="payroll-summary-header-body-item dedution-amount" *ngIf="!showSkeleton">
                <div class="card-head">
                  <div class="card-img">
                    <img src="../../../../assets/theme1/smal-icons/total-deduction.png" />
                  </div>
                  <div class="card-content">
                    <p><span>Total</span> Deduction</p>
                    <h2>{{ detailData?.summary?.total_deduction | number }} /- PKR</h2>
                  </div>
                </div>
              </div>

              <div class="payroll-summary-header-body-item final-amount" *ngIf="!showSkeleton">
                <div class="card-head">
                  <div class="card-img">
                    <img src="../../../../assets/theme1/smal-icons/loan-icon.png" />
                  </div>
                  <div class="card-content">
                    <p><span>Total</span> Loan</p>
                    <h2>{{ detailData?.summary?.total_loan | number }} /- PKR</h2>
                  </div>
                </div>
              </div>

              <div class="payroll-summary-header-body-item pending-amount" *ngIf="!showSkeleton">
                <div class="card-head">
                  <div class="card-img">
                    <img src="../../../../assets/theme1/smal-icons/pending-payroll.png" />
                  </div>
                  <div class="card-content">
                    <p><span>Total</span> Tax</p>
                    <h2>{{ detailData?.summary?.total_tax | number }} /- PKR</h2>
                  </div>
                </div>
              </div>
              <div class="payroll-summary-header-body-item release-amount card-big-div" *ngIf="showSkeleton"></div>
              <div class="payroll-summary-header-body-item release-amount card-big-div" *ngIf="showSkeleton"></div>
              <div class="payroll-summary-header-body-item release-amount card-big-div" *ngIf="showSkeleton"></div>
              <div class="payroll-summary-header-body-item release-amount card-big-div" *ngIf="showSkeleton"></div>
              <div class="payroll-summary-header-body-item release-amount card-big-div" *ngIf="showSkeleton"></div>
            </div>
            <div class="payroll-detail-body">
              <div class="table-container">
                <table class="responsive-table">
                  <thead>
                    <tr>
                      <th>Month</th>
                      <th>Release Date</th>
                      <th>Gross Salary</th>
                      <th>Total Deduction</th>
                      <th>Over Time</th>
                      <th>Compensation</th>
                      <th>Net Salary</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="showSkeleton">
                      <td colspan="8">
                        <div class="skeleton-row" *ngFor="let n of [1,2,3,4,5,6,7,8,9,10]">
                          <div class="skeleton-cell" *ngFor="let i of [1,2,3,4,5,6,7,8]"></div>
                        </div>
                      </td>
                    </tr>
                    <ng-container *ngIf="!showSkeleton">
                      <tr *ngFor="let month of detailData?.monthly_salaries?.data">
                        <td>{{ month.month_char }} ({{ month.month_year }})</td>
                        <td>{{ formatDate(month.salary_released_date) || '-' }}</td>
                        <td>{{ month.basic_salary | number }}</td>
                        <td>{{ month.total_deduction | number }}</td>
                        <td>{{ month.overtime_amount || 0 | number }}</td>
                        <td>{{ month.compensation_amount || 0 | number }}</td>
                        <td>{{ (month.released_salary) | number }}</td>
                        <td class="action-eye">
                          <div class="active-button" (click)="showSlip(month, detailData?.user_detail)">
                            <img src="../../../../assets/theme1/smal-icons/eye-purple.svg" alt="eye icon" />
                          </div>
                        </td>
                      </tr>
                    </ng-container>

                  </tbody>
                </table>
              </div>

            </div>
          </div>

        </div>
      </div>
      <div class="pagination-sec" *ngIf="pageNumbers.length > 1">
        <div class="paggination-buttons">
          <div class="arrow-sec left-pag-arrow" (click)="goPrev()">
            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.25 0.75L0.75 5.25L5.25 9.75" stroke="#00989B" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>

          <div class="page-numbers">
            <p *ngFor="let page of pageNumbers" [ngClass]="{'active-page': page === currentPage}"
              (click)="goToPage(page)">
              {{ page }}
            </p>
          </div>

          <div class="arrow-sec right-pag-arrow" (click)="goNext()">
            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.75 0.75L5.25 5.25L0.75 9.75" stroke="#00989B" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade payroll-modal pl-0" id="deductionModal" tabindex="-1" role="dialog" aria-labelledby="basicModal"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content payroll-modal-content">
      <div class="modal-header payroll-modal-header justify-content-center deduction-header">
        <h1>Total Deductions</h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="../../../../assets/theme1/smal-icons/circle-black-cross.png" alt="image" />
        </button>
      </div>

      <div class="modal-body payroll-modal-body deduction-modal-body">
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head">
              <h1 class="title-head">Category</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head">
              <h1 class="title-head">Duration</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1 class="title-head">Deduction</h1>
            </div>
          </div>
        </div>
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head category-head">
              <h1>Absents</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head duration-text-center">
              <h1>96</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1>-200/-PKR</h1>
            </div>
          </div>
        </div>
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head category-head">
              <h1>Late Check In</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head duration-text-center">
              <h1>96</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1>-200/-PKR</h1>
            </div>
          </div>
        </div>
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head category-head">
              <h1>Short Hours</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head duration-text-center">
              <h1>96</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1>-200/-PKR</h1>
            </div>
          </div>
        </div>
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head category-head">
              <h1>Unpaid Leaves</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head duration-text-center">
              <h1>96</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1>-200/-PKR</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade payroll-modal pl-0" id="userpayrollModal" tabindex="-1" role="dialog"
  aria-labelledby="basicModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content payroll-modal-content">
      <div class="modal-header payroll-modal-header justify-content-left">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="../../../../assets/theme1/smal-icons/circle-black-cross.png" alt="image">
        </button>
      </div>

      <div class="modal-body payroll-modal-body text-center payroll-modal-body">
        <img src="../../../../assets/theme1/smal-icons/calendar-3d.png" alt="image">
        <h1 class="mt-3">Select Month</h1>
        <div class="month-picker">
          <div class="month-picker-header">
            <button (click)="prevYear()">
              <img src="../../../../assets/theme1/smal-icons/left-arrow.png" alt="missing icon">
            </button>
            <span>{{ modalcurrentYear }}</span>
            <button (click)="nextYear()">
              <img src="../../../../assets/theme1/smal-icons/right-arrow.png" alt="missing icon">
            </button>
          </div>

          <div class="month-grid">
            <div *ngFor="let month of months; let i = index" class="month-cell" [class.selected]="i === selectedMonth"
              (click)="userPayrolselectMonth(i)">
              {{ month }}
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>